import axios from "axios";
import { Article } from "./updateArticle";

// Tek bir makale çekmek için (slug ile)
export const getArticle = async (slug: string, token?: string): Promise<Article | null> => {
    try {
        const headers = token ? { Authorization: `Bearer ${token}` } : undefined;

        const response = await axios.get(
            `https://portfoliom-backend.vercel.app/articles/article/${slug}`,
            { headers }
        );

        return response.data || null;
    } catch (error) {
        if (axios.isAxiosError(error)) {
            console.error("Axios hatası:", error.response?.data || error.message);
        } else {
            console.error("Bilinmeyen hata:", error);
        }
        return null;
    }
};
